// @flow

export const HOME_PAGE_ROUTE = '/';
export const POPULAR_PAGE_ROUTE = '/popular';
export const PEOPLE_PAGE_ROUTE = '/people';
export const MOVIE_PROFILE_PAGE_ROUTE = '/movie_profile';
export const PEOPLE_PROFILE_PAGE_ROUTE = '/people_profile';
export const SEARCH_PAGE_ROUTE = '/search';
